import { t } from '../../../../../common/i18n.js'
import type { Language } from '../../../../../common/types/i18n.js'

/**
 * Resolve a dotted i18n path (e.g. "portal.dashboard.cards.headcount.title")
 * into a string for the given language. Returns the path itself as a fallback
 * if the node does not resolve to a translator function or string.
 */
export const lookupI18n = (path: string, lang: Language): string => {
    const parts = path.split('.')
    let node: unknown = t
    for (const p of parts) {
        if (node && typeof node === 'object') {
            node = (node as Record<string, unknown>)[p]
        } else {
            return path
        }
    }
    if (typeof node === 'function') {
        return (node as (l: Language) => string)(lang)
    }
    if (typeof node === 'string') return node
    return path
}
